import { AdviseProductType } from '../../../types/advise';

export const ccaasProductType: AdviseProductType = {
  id: 'ccaas',
  name: 'UCaaS',
  description: 'Contact Center as a Service',
  roiCalculators: ['baseline', 'conversational_ai', 'automated_qm', 'real_time_assist']
};
